let module = angular.module('confirm-dialog', []);

module.service('ConfirmDialog', function ($uibModal) {
  'ngInject';

  var modalDefaults = {
    backdrop: true,
    keyboard: true,
    modalFade: true,
    template: `
      <div class="modal-header">
        <h3 class="modal-title">{{modalOptions.headerText}}</h3>
      </div>
      <div class="modal-body">
        <p>{{modalOptions.bodyText}}</p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-{{modalOptions.closeButtonClass}}" data-ng-click="modalOptions.close()">{{modalOptions.closeButtonText}}</button>
        <button class="btn btn-{{modalOptions.actionButtonClass}}" data-ng-click="modalOptions.ok();">{{modalOptions.actionButtonText}}</button>
      </div>
    `,
  };

  var modalOptions = {
    closeButtonText: 'Close',
    closeButtonClass: 'default',
    actionButtonText: 'OK',
    actionButtonClass: 'primary',
    headerText: 'Proceed?',
    bodyText: 'Perform this action?',
  };

  this.showModal = function (customModalOptions, customModalDefaults) {
    if (!customModalDefaults) customModalDefaults = {};
    customModalDefaults.backdrop = 'static';
    return this.show(customModalDefaults, customModalOptions);
  };

  this.show = function (customModalOptions, customModalDefaults) {
    //Create temp objects to work with since we're in a singleton service
    var tempModalDefaults = {};
    var tempModalOptions = {};

    //Map angular-ui modal custom defaults to modal defaults defined in service
    angular.extend(tempModalDefaults, modalDefaults, customModalDefaults);

    //Map modal.html $scope custom properties to defaults defined in service
    angular.extend(tempModalOptions, modalOptions, customModalOptions);

    if (!tempModalDefaults.controller) {
      tempModalDefaults.controller = function ($scope, $uibModalInstance) {
        'ngInject';
        $scope.modalOptions = tempModalOptions;
        $scope.modalOptions.ok = function (result) {
          $uibModalInstance.close(result);
        };
        $scope.modalOptions.close = function (result) {
          $uibModalInstance.dismiss('cancel');
        };
      };
    }

    return $uibModal.open(tempModalDefaults).result;
  };
});

export default module;



// WEBPACK FOOTER //
// ./app/services/confirm-dialog.js